import MockAdapter from 'axios-mock-adapter'
import { mockedAxios } from '../axios'

export const mock = new MockAdapter(mockedAxios, { delayResponse: 1500 })

export default mock
